import { useState } from 'react'
import axios from 'axios'
import { API_BASE_URL } from '../config/api'

export const useMediaDeletion = (eventId, onMediaUpdate, onError) => {
  const [deleting, setDeleting] = useState(false)
  const [deleteError, setDeleteError] = useState(null)

  const deleteMedia = async (mediaId, closeModal) => {
    try {
      setDeleting(true)
      setDeleteError(null)
      const response = await axios.delete(
        `${API_BASE_URL}/api/events/${eventId}/media/${mediaId}`,
        { withCredentials: true }
      )

      if (onMediaUpdate && response.data?.event) {
        onMediaUpdate(response.data.event)
      }

      if (closeModal) {
        closeModal()
      }

      return true
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Failed to delete media'
      setDeleteError(errorMessage)
      if (onError) {
        onError(errorMessage)
      }
      throw err
    } finally {
      setDeleting(false)
    }
  }

  return { deleteMedia, deleting, error: deleteError }
}
